import { Link } from "react-router-dom";
import PageBanner from "@/components/feature/PageBanner";
import { product } from "@/mocks/product";

function StarIcon({ filled }: { filled: boolean }) {
  if (filled) {
    return (
      <i className="ri-star-fill w-3.5 h-3.5 flex items-center justify-center text-secondary-500 text-sm" />
    );
  }
  return (
    <i className="ri-star-line w-3.5 h-3.5 flex items-center justify-center text-secondary-500 text-sm" />
  );
}

export default function Shop() {
  return (
    <div>
      <PageBanner
        title="Shop"
        subtitle="Explore our curated collection of cotton ethnic wear. More styles coming soon."
        bgImage="/images/shop-banner.jpg"
      />

      <section className="py-10 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8"
            data-product-shop
          >
            <div className="group bg-background-100 rounded-2xl overflow-hidden shadow-sm border border-background-200/70 transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
              <Link
                to={`/product/${product.slug}`}
                className="block relative aspect-[3/4] overflow-hidden bg-background-200"
              >
                <img
                  src={product.images[0].src}
                  alt={product.images[0].alt}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-secondary-100 text-secondary-900 text-xs font-semibold rounded-md">
                  {product.discount}
                </span>
              </Link>

              <div className="p-5 md:p-6">
                <div className="flex items-center gap-1 mb-1.5">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <StarIcon
                      key={i}
                      filled={i <= Math.floor(product.rating)}
                    />
                  ))}
                  <span className="text-xs text-foreground-500 ml-1">
                    ({product.ratingCount})
                  </span>
                </div>

                <Link
                  to={`/product/${product.slug}`}
                  className="block font-heading text-base md:text-lg font-semibold text-accent-800 mb-2 hover:text-primary-500 transition-colors"
                >
                  {product.name}
                </Link>

                <div className="flex items-center gap-2 mb-4">
                  <span className="text-lg md:text-xl font-bold text-foreground-950">
                    ₹{product.price}
                  </span>
                  <span className="text-sm text-foreground-400 line-through">
                    ₹{product.originalPrice}
                  </span>
                </div>

                <Link
                  to={`/product/${product.slug}`}
                  className="inline-flex items-center justify-center gap-2 w-full px-5 py-2.5 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-secondary-500 transition-colors whitespace-nowrap"
                >
                  View Product
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}